import React from 'react';
import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';
import { Divider } from '@components/atoms';

export interface PopupProps {
  header?: {
    title?: string | React.JSX.Element;
    desc?: string | React.JSX.Element;
  };
  body?: string | React.JSX.Element;
  footer?: string | React.JSX.Element;
  styles?: SerializedStyles;
}
const Popup = ({ header, body, footer, styles }: PopupProps) => {
  return (
    <PopupWrapper styles={styles}>
      <PopupHeader>
        <h1>{header?.title || ''}</h1>
        {header?.desc || ''}
      </PopupHeader>
      <PopupBody>{body}</PopupBody>
      <Divider
        data-orientation="horizontal"
        styles={css`
          width: auto !important;
          margin: 10px 40px;
        `}
      />
      <PopupFooter>{footer}</PopupFooter>
    </PopupWrapper>
  );
};

export const PopupWrapper = styled.article`
  width: 100vw;
  & > article {
    padding: 0 20px;
  }
  ${(props: PopupProps) => props.styles}
`;

export const PopupHeader = styled.article`
  margin-bottom: 40px;
  font-size: 14px;
  & > h1 {
    margin: 10px auto;
    font-size: 24px;
    line-height: 35px;
  }
`;

export const PopupBody = styled.article`
  overflow: visible;
  & > table {
    width: 100%;
    border-spacing: 0;
    thead {
      background: white;
      th {
        border-right: 1px solid white;
      }
    }
    tbody {
      td {
        border-style: solid;
        border-color: #e0e0e0;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 1px;
        border-bottom-width: 1px;
        &:nth-last-of-type(1) {
          border-right-width: 0;
        }
      }
    }
  }
`;

export const PopupFooter = styled.article`
  display: flex;
  justify-content: center;
`;

export default Popup;
